import { render } from "./ReplyCommentForm.vue?vue&type=template&id=8a6453e0"
import script from "./ReplyCommentForm.vue?vue&type=script&lang=js"
export * from "./ReplyCommentForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__